import { createAction } from 'redux-actions';

export const makeQCSApiCall = createAction('APIUTIL_MAKEQCSAPICALL');
export const makeGeneralApiCall = createAction('APIUTIL_MAKEGENERALAPICALL');
